import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { ArrowUpRightIcon } from '@heroicons/react/24/outline';
import tabletImage from '../assets/man-is-holding-tablet-with-graph-him_479259-14595.jpg_dz4zsm.jpg';

const NextGenSection = () => {
  return (
    <section className="py-16 lg:py-24 bg-black text-white">
      <div className="section-container">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          {/* Left Content - Text */}
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ 
              duration: 1.2, 
              ease: [0.25, 0.46, 0.45, 0.94],
              delay: 0.2 
            }}
            viewport={{ once: true, margin: "-100px" }}
          >
            <motion.h2 
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: 0.4 }}
              viewport={{ once: true }}
              className="text-3xl lg:text-4xl xl:text-5xl font-bold mb-6 leading-tight"
            >
              Driving the next generation of wealth.
            </motion.h2>
            
            <motion.p 
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: 0.6 }}
              viewport={{ once: true }}
              className="text-lg lg:text-xl text-gray-300 leading-relaxed mb-8"
            >
              Segway is built for forward-thinking investors ready to leverage blockchain technology and Web3 innovations for wealth generation, guided by experienced wealth management professionals. Create your account today and get started.
            </motion.p>

            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: 0.8 }}
              viewport={{ once: true }}
              className="flex items-center gap-4"
            >
              <Link to="/apply-now">
                <motion.button
                  whileHover={{ scale: 1.02 }}
                  whileTap={{ scale: 0.98 }}
                  className="bg-teal-500 hover:bg-teal-600 text-white px-8 py-4 rounded-2xl font-medium inline-flex items-center gap-3 text-lg transition-colors duration-200"
                >
                  Sign up
                  <ArrowUpRightIcon className="w-5 h-5" />
                </motion.button>
              </Link>

              {/* QR Code/App Download Button */}
              <motion.button
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                className="w-12 h-12 bg-white/10 hover:bg-white/20 rounded-xl flex items-center justify-center transition-colors duration-200"
              >
                <svg className="w-6 h-6 text-white" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M3,3H11V5H5V11H3V3M3,13H5V19H11V21H3V13M13,3V5H19V11H21V3H13M19,13H21V21H13V19H19V13Z"/>
                </svg>
              </motion.button>
            </motion.div>
          </motion.div>

                     {/* Right Content - Tablet Image */}
           <motion.div
             initial={{ opacity: 0, x: 30 }}
             whileInView={{ opacity: 1, x: 0 }}
             transition={{ 
               duration: 1.2, 
               ease: [0.25, 0.46, 0.45, 0.94],
               delay: 0.4 
             }}
             viewport={{ once: true, margin: "-100px" }}
             className="relative"
           >
             {/* Background Gradient */}
             <div className="absolute inset-0 bg-gradient-to-br from-orange-400 via-pink-500 to-purple-600 rounded-3xl blur-3xl opacity-20"></div>
             
             {/* Tablet Image */}
             <motion.div
               initial={{ opacity: 0, scale: 0.8 }}
               whileInView={{ opacity: 1, scale: 1 }}
               transition={{ duration: 1, delay: 0.6 }}
               viewport={{ once: true }}
               className="relative mx-auto w-full max-w-lg"
             >
               <img 
                 src={tabletImage} 
                 alt="Man holding tablet with financial graphs" 
                 className="w-full h-auto rounded-2xl shadow-2xl object-cover"
                 loading="eager"
               />
             </motion.div>
           </motion.div>
        </div>
      </div>
    </section>
  );
};

export default NextGenSection; 